export const DEV_HOST_URL = "http://172.24.11.72:8090/";
export const QA_HOST_URL = "http://172.24.11.72:8091/";
export const AWS_UAT_HOST_URL = "http://35.170.6.130:8080/";
export const AWS_QA_HOST_URL = "http://35.170.6.130:8081/";
export const AWS_DEV_TEMP_HOST_URL = "http://35.170.6.130:8083/";
export const AWS_DEV_HOST_URL = "http://35.170.6.130:8082/"; //Use AWS DEV URL// Changed port from 8081 to 8082 -- Akash //,,,,,,,,,,,
export const STAGING_HOST_URL = "https://staging.allwellapp.com/";
export const LOCAL_HOST_URL = "http://127.0.0.1:8090/";
//export const STAGING_HOST_URL = "https://dev.allwellapp.com/";

export const PROD_HOST_URL = "https://api.allwellapp.com/";

export const BuildEnvironments = {
    DEV: "DEV",
    QA: "QA",
    AWS_DEV: "AWS_DEV",
    AWS_QA: "AWS_QA",
    AWS_UAT: "AWS_UAT",
    STAGING: "STAGING",
    PRODUCTION: "PRODUCTION",
    LOCAL:"LOCAL",
};
export const API_BASE_URL = PROD_HOST_URL;
export const BUILD_ENVIRONMENT = BuildEnvironments.PRODUCTION; //Change this to use different type of environments
export const DEFAULT_REQUEST_TIMEOUT = 60000; // 3min //300000; //5 min // 45000 - 45 secs

export const MAX_NUMBER_OF_RETRIES = 15;
export const HttpMethod = {
    GET: "get",
    PUT: "put",
    POST: "post", //,,,,,,,
    DELETE: "delete",
};

export const HttpStatus = {
    //,,,,,,,,,,,,
    // OK: 200,
    // ACCEPTED: 202,
    // BAD_REQUEST: 400,
    // UNAUTHORIZED: 401,
    // ACCESS_DENIED: 402,
    // ACCESS_FORBIDDEN: 403,
    // RESOURCE_NOT_FOUND: 404,
    // SERVER_ERROR: 500
    OK: 200,
    BAD_REQUEST: 400,
    UNAUTHORIZED: 401,
    RESOURCE_NOT_FOUND: 404,
    INTERNAL_SERVER_ERROR: 500,
};

//Add app level error codes here
export const OperationStatus = {
    SUCCESS: 0, //,,,,,,,,,,,,,,,
    FAILURE: 1, //,,,,,,,,,,
    NETWORK_NOT_REACHABLE: 2,
    DEVICE_REGISTRATION_FAILED_FOR_PUSH_NOTIFICATION: 3,
    REQUEST_TIMEOUT: 4,
    DB_HANDLER_FAILURE: 5,
    IN_PROGRESS: 6,
    MANDATORY_FIELDS_CANT_BE_EMPTY: 7,
};

// API response  code
export const APIResponse = {
    APPLICATION_ERROR: 1001,
    ACCOUNT_ALREADY_EXIST: 1002,
    ACCOUNT_ALREADY_REGISTERED: 1004,
    USER_NOT_FOUND: 1006,
    JWT_TOKEN_EXPIRED: 1007,
    INVALID_JWT_TOKEN: 1008,
    REQUEST_FIELD_NOT_PRESENT_OR_INVALID: 1013,
    INVALID_DEVICE_TYPE: 1014,
    INVALID_USER_AGENT: 1015,
    EMAIL_ALREADY_EXISTS: 1016,
    WEB_CONSOLE_LOGIN_NOT_ALLOWED: 1017,
    INVALID_FIRST_NAME: 2001,
    INVALID_LAST_NAME: 2002,
    INVALID_MOBILE_NUMBER: 2005,
    INVALID_TIMEZONE: 2013,
    INVALID_AUTH_GRANT: 2014, //,,,,,
    INVALID_ARGUMENT: 2015,
    ACCESS_DENIED_ERROR: 2016,
    INVALID_CLIENT: 2017,
    INVALID_REQUEST: 2018,
    INSUFFIECIENT_SCOPE: 2019,
    INVALID_SCOPE: 2020,
    UNAUTHORIZED_CLIENT: 2021,
    UNAUTHORIZED_REQUEST: 2022,
    UNSUPPORTED_GRANT_TYPE: 2023,
    UNSUPPORTED_RESPONSE_TYPE: 2024,
    SERVER_ERROR: 2025,
    INVALID_COUNTRY_CALLING_CODE: 2027,
    INVALID_REFRESH_TOKEN: 2029,
    INVALID_CLIENT_ID: 2030,
    INVALID_CLIENT_SECRET_KEY: 2031,
    INVALID_DEVICE_TOKEN: 2032,
    INVALID_USER_ID: 2033,
    INVALID_USER_PROFILE: 2034,
    OPERATION_NOT_ALLOWED: 2035,
    INVALID_INVITE_ID: 2037,
    INVALID_INVITATION: 2038,
    INVITATION_DOESNOT_BELONG_TO_USER: 2039,
    INVALID_PARAMETER_ID: 2042,
    INVALID_PARAMETER_NAME: 2044,
    INVALID_RECORDED_TIMESTAMP: 2049,
    INVALID_GRANT_TYPE: 2056,
    INVALID_VALUE: 2057,
    SUMMARY_NOT_FOUND: 2058,
    INVALID_FOR_DATE: 2059,
    INVALID_FOR_USER_ID: 2062,
    MAPPING_NOT_FOUND: 2063,
    INVALID_MAX_VALUE: 2064,
    INVALID_MIN_VALUE: 2065,
    INVALID_AVG_VALUE: 2066,
    INVALID_START_TIME: 2067,
    INVALID_END_TIME: 2068,
    INVALID_INTERVAL: 2069,
    INVALID_USER_TYPE: 2070,
    INVALID_PARAMETERS: 2071,
    INVALID_TRANSACTION_ID: 2072,
    MONITERING_USERS_NOT_FOUND: 2073,
    INVALID_RELATIONSHIP: 2074,
    EMAIL_SENT_FAILURE_TO_PRECONFIGURED_SUPPORT_EMAIL_ID: 2078,
    INVALID_EMAIL_SUBJECT: 2079,
    INVALID_EMAIL_MESSAGE: 2080,
    INVALID_EMAIL_TOPIC: 2084,
    INVALID_BIRTH_YEAR: 2092,
    UNSPPORTED_APP_VERSION: 3000,
    CONN_NOT_FOUND: 3001,
    PAID_CONN_CANNOT_REM: 3002,
    START_DATE_OUT_OF_SUBSCRIPTION_RANGE: 2103,
    END_DATE_OUT_OF_SUBSCRIPTION_RANGE: 2104,
    INCOMING_TRANSACTION_ALREADY_ACTIVE: 2093,
    INCOMING_TRANSACTION_ALREADY_COMPLETED: 2094,
    INCOMING_PAYMENT_REQUEST_FAILED: 2095,
    IN_APP_PRODUCT_ID_DOESNNOT_EXISTS: 2096,
    INVALID_PAYMENT_METHOD_USER: 2097,
    PAYMENT_METHOD_DOESNOT_MATCH_DEFAULT_METHOD: 2098,
    UNSUBSCRIBE_REQUEST_IS_INVALID: 2099,
    INVALID_SUBSCRIPTION_ID_FOR_UNSUBSCRIPTION: 2100,
    UNSUBSCRIPTION_WAS_UNSUCCESSFUL: 2102,
    INVALID_PLAN_ID_FOR_STRIPE_REQUEST: 2105,
    FAILED_TO_CREATE_SUBSCRIPTION: 2106,
    INVALID_CONNECTIONS_FOR_SUBSCRIPTION: 2107,
    INVITATION_FROM_SUBSCRIPTION_ALREADY_PRESENT: 2120,
    INVALID_OTP: 2116,
    USER_ALREADY_REGISTERED_AS_SENIOR: 2117,
    MOBILE_NUMBER_ALREADY_CONNECTED_TO_SENIOR: 2118,
    INVALID_CARD_NUMBER: 2110,
    INVALID_REPORT_RECIPIENT_ID: 2136,
    ALERTS_LIMIT_REACHED: 2142,
    INVALID_GOOGLE_TOKEN: 2160,
    MOBILE_ALREADY_EXISTS: 2162,
    INVALID_OTP_IN_SETTING:2163,
    COUPON_NOT_FOUND: 3012,
    COUPON_LIMIT_EXCEEDED: 3014,
    CANNOT_APPLY_COUPON: 3016,

    INVALID_WEB_TOKEN: 3057,
    WEB_TOKEN_EXPIRED: 3058,
    WEB_TOKEN_NOT_FOUND: 3059,
    FAILED_TO_VERIFY_TOKEN: 3062,
    INVITATION_WITH_GIVEN_ID_NOT_FOUND: 3055,
    EMAIL_VERIFIED_ALREADY: 3080,
    TOKEN_INFO_NOT_FOUND: 2190,
    TOKEN_MISMATCH:2191,

    //report
    INVALID_REPORT_OF_USER:2122,
    INVALID_RECIPIENTS:2123,
    INVALID_RECIPIENT_ID:2124,
    INVALID_RECIPIENT_NAME:2125,
    INVALID_RECIPIENT_EMAIL:2126,
    INVALID_REPORTS:2127,
    INVALID_ID:2050,
    INVALID_NAME:2051,
    INVALID_FREQUENCY:2128,
    INVALID_DAY:2129,
    INVALID_TIME:2121,
    INVALID_DATE:2132,
    INVALID_SCHEDULE_TYPE:2135,
    FAILED_TO_CREATE_REPORT:2134
};

export const API_URL = {
    //Authentication APIs
    VERIFY_EMAIL: "users/emails/verify", //Not in use
    SEND_ACTIVATION_EMAIL: "users/emails/activation", //Not in use
    SIGNUP: "auth/otp/send", // In use - tested error handling changes //,,,,,,,,,,
    LOGIN: "auth/token", // ? neecds to use for refresh token
    INVITE_USER: "invite", //Not in use
    LOCATION:"location",
    SUMMARY: "/summary", // In use - for home
    BASE_USER_URL: "users/",
    v1: "v1/",
    v2: "v2/",
    LOGOUT:"logout",
    SEND_OTP:"sendotp",
    ALERTS: "alerts",
    DISABLE: "/disable",
    VERIFYGOOGLE:"verify/email/google",
    VERIFY_OTP: "auth/otp/verify", // In use - tested error handling changes
    VERIFYOTP:"verifyotp",
    SEND_USER_DATA: "/data/summary", //In use - from home
    USER_MONITOR_MAPPING: "/mapping", //In use - needs to check with Mayuresh
    INVITE_SENIORS: "users/invite/seniors",
    INVITE_CAREGIVERS: "users/invite/caregivers",
    LIST_MONITORED_MONITORING_USERS: "mapping",
    REMOVE: "/remove",

    ACCEPT_DECLINE_INVITATIONS: "/invite/reply",
    HISTORY: "/data/history",
    SUPPORT_SEND_EMAIL: "support/send/email",
    GET_PROUDUCT_PLAN: "subscription/products",
    PLAN_TRANSACTION: "subscription/transaction",
    SUBSCRIPTION_RECEIPT: "subscription/iap/receipt",
    GET_PAYMENT_METHODS: "subscription/customer/",
    SUBSCRIPTION_PAY: "subscription/pay",
    UNSUBSCRIBE: "subscription/unsubscribe/",
    TRANSACTION_HISTORY: "subscription/history",
    REPORTS: "reports",
    GET_INVITATION_INFO: "invites",
    GET_TOKEN: "auth/token/verify",
    GET_ACCESS_TOKEN: "subscription/token/generate",
    GOOGLE_SIGN_IN: "auth/google",
    CONFIG: "config"
};

export const DATA_PASSING_KEYS = {
    SendUserData: "SendHealthData",
    PermissionsAccepted: "PermissionsAccepted",
    AndroidSystemPermissions: "androidSystemPermissions",
    GoogleFitPermissionsAccepted: "GoogleFitPermissionsAccepted",
    SendContact: "SendContact",
    FetchSummaryData: "FetchSummaryData",
    UpdateAccessToken: "UpdateAccessToken",
    CreatePaymentMethod: "CreatePaymentMethod",
};

export const LANDING_PAGE_MONITORED_STATUS = {
    IS_MONITORED_BY: 1,
    IS_MONITORED: 0,
};

export const DATABASE_QUERIES = {
    DropAllTables:
        "DROP TABLE IF EXISTS ActivityInfo;DROP TABLE IF EXISTS UserConfig",
    CreateUserConfig:
        "CREATE TABLE IF NOT EXISTS UserConfig(ConfigName TEXT PRIMARY KEY NOT NULL, ConfigValue TEXT);",
    CreateActivityInfo:
        "CREATE TABLE IF NOT EXISTS ActivityInfo(Id INTEGER PRIMARY KEY AUTOINCREMENT, StartRecordedTimestamp TEXT UNIQUE, LastRecordedTimestamp TEXT, UserActivityData TEXT, Status INTEGER);",
    InsertUserConfigInfo:
        "INSERT OR REPLACE INTO UserConfig (ConfigName, ConfigValue) VALUES (?,?)",
    InsertActivityInfo:
        "INSERT OR REPLACE INTO ActivityInfo (StartRecordedTimestamp, LastRecordedTimestamp, UserActivityData, Status) VALUES (?,?,?,?)",
    SelectActivityInfo:
        "SELECT * FROM ActivityInfo WHERE Status == ? OR Status == ?;",
    DeleteActivityInfo: "DELETE FROM ActivityInfo WHERE Id == ?;",
    UpdateActivityInfoStatus: "UPDATE ActivityInfo SET Status = ?;",
};


export const PLATFORM = {
    ANDROID: 1,
    IOS: 2,
    WEB:3,
    ANDROID_MANUAL: 4,
    IOS_MANUAL: 5,
}


export const HISTORY_INTERVAL = {
    HOURLY: "HOURLY",
    DAILY: "DAILY",
};

export const SUMMARY_PARAM_IDS = {
    Footsteps: 4,
    Distance: 5,
    Calories: 6,
    SleepTime: 7,
    HeartRate: 9,
    Emotions: 14,
    ScreenTime: 15,
    BloodPressure: 10,
}


export const SUMMARY_PARAM_NAMES = {
    Footsteps: "footsteps",
    Distance: "distance_covered",
    Calories: "calories_consumed",
    Emotions: "emotional_state",
    ScreenTime: "screen_interaction_time",
    wakeupTime: "first_phone_usage",
    SleepTime: "sleep_data",
    HeartRate: "heart_rate_day",
    BloodPressure: "blood_pressure",
}




export const INVITE_ACTION = {
    ACCEPTED: "ACCEPTED",
    DECLINED: "DECLINED",
};

export const SettingsWebPage = {
    TermsConditions: 0,
    PrivacyPolicy: 1,
    Contact: 2,
    TermsOfUse: 3,
    FAQ: 4,
};

export const SettingsWebPageInfo = [
    {
        title: "TermsConditions",
        url: "https://allwellapp.com/terms",
    },
    {
        title: "PrivacyPolicy",
        url: "https://allwellapp.com/privacy-policy/",
    },
    {
        title: "CONTACTUS",
        url: "https://www.google.com/",
    },
    {
        title: "TermsOfUse",
        url: "https://allwellapp.com/terms",
    },
    {
        title: "FAQ",
        url: "https://allwellapp.com/app-faq",
    },
];
export const SUBSCRIPTION_INTERVAL = {
    MONTHLY: "month",
    ANNUAL: "year",
};

export const SUBSCRIPTION_PLANS = {
    FREE: 1,
    PLUS: 2,
    PREMIUM: 3,
    BASIC: 5,
    STANDARD: 6,
    NEW_PREMIUM: 7,
    ADVANCED: 8,
    PRO_PREMIUM: 4,
};

export const SUBSCRIPTION_PLAN_NAME = {
    FREE: "FREE",
    PLUS: "PLUS",
    PREMIUM: "PREMIUM",
    BASIC: "BASIC",
    STANDARD: "STANDARD",
    NEW_PREMIUM: "NEW_PREMIUM",
    ADVANCED: "ADVANCED",
    PRO_PREMIUM: "PRO-PREMIUM"
};

export const SUBSCRIPTION_PLAN_COLOR = {
  freePlanColor: '#67D698',
  basicPlanColor: '#3DD8C5',
  standardPlanColor: '#8680F5',
  premiumPlanColor: '#8680F5',
  advancedPlanColor: '#8680F5',
}
export const SUBSCRIPTION_STATUS = {
    ACTIVE: "ACTIVE",
    CANCELLED: "CANCELLED",
};

export const ALERTS_STATUS = {
    INACTIVE: 0,
    ACTIVE: 1
};
export const GOOGLE_WEB_CLIENT_ID = "325251870880-8n0uubhnp8ihmre45ocn2qlj4jdsls53.apps.googleusercontent.com";
export const GOOGLE_SIGNIN_ERRORS = {
    NETWORK_ERROR: 7,//Received from Google
};

